import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {GridModel} from "../../../shared/model/page-grid";
import {MatchingVccPaymentGridService} from "../../service/matching-vcc-payment-grid.service";
import {DatePipe} from "@angular/common";
import {firstValueFrom} from "rxjs";
import {MatchingVccDetails} from "../../model/match-vcc";

@Component({
    selector: 'app-matching-vcc-payment-detail-report',
    templateUrl: './matching-vcc-payment-detail-report.component.html',
    standalone: false
})
export class MatchingVccPaymentDetailReportComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly datePipe = inject(DatePipe);

  protected readonly isReady = computed(() => !!this.gridConfig().filtersInitial?.connexPayAccountingDailyDetailId);

  public readonly gridConfig = signal<GridModel<any>>({
    gridDataTestId: 'connexpay-vcc-payment-detail',
    gridTitle: 'Connexpay Vcc Payment Detail',
    gridTitleFunction: (filter: any) => `Connexpay Vcc Payment Detail For ${filter?.clientName ?? ''} - ${filter?.cardLastFour ?? ''}`,
    replayButton: true,
    columns: [
      {
        columnProperty: 'clientName',
        columnHeader: 'Merchant Name',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'cardLastFour',
        columnHeader: 'Card Last Four',
        sort: true,
      },
      {
        columnProperty: 'merchantName',
        columnHeader: 'Vcc Provider Name',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'releasedDate',
        columnHeader: 'Vcc Provider Released Date',
        sort: true,
        processData: (item) => this.datePipe.transform(item, 'M/dd/yyyy') ?? '',
      },
      {
        columnProperty: 'connexPayAccountingDailyDetailAmount',
        columnHeader: 'Vcc Provider Total',
        sort: true,
      },
      {
        columnProperty: 'adxCCAmount',
        columnHeader: 'Booking Total',
        sort: false,
      },
      {
        columnProperty: 'tramsBookingTotalFare',
        columnHeader: 'Trams Total',
        sort: false,
      },
      {
        columnProperty: 'tramsBookingCommAmt',
        columnHeader: 'Agent Commission',
        sort: false,
      },
      {
        columnProperty: 'cogs',
        columnHeader: 'Cogs',
        sort: false,
      },
      {
        columnProperty: 'adxTripReference',
        columnHeader: 'Trip Record Locator',
        sort: true,
      },
      {
        columnProperty: 'tramsInvoiceNumber',
        columnHeader: 'Trams Invoice Number',
        sort: false,
      },
      {
        columnProperty: 'agentName',
        columnHeader: 'Agent Name',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'tramsInvoiceIssueDate',
        columnHeader: 'Card Issued Date',
        sort: false,
        processData: (item) => this.datePipe.transform(item, 'M/dd/yyyy') ?? '',
      },
      {
        columnProperty: 'travelerName',
        columnHeader: 'Traveler Name',
        sort: false,
      },
    ],
    gridGetService: inject(MatchingVccPaymentGridService)
  });

  public ngOnInit() {
    this.getData();
  }

  private async getData() {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) return;
    const data = await firstValueFrom(this.route.data);
    const resolvedData: MatchingVccDetails = data['data'][0];
    const {
      merchantName,
      connexPayTripReferenceNumber,
      vccNumber,
      connexPayDescription,
      chargeDate,
      fmsBookingId,
      merchantGuid,
      releasedDate,
      cardGuid,
    } = resolvedData;

    const prevConfig = this.gridConfig();
    this.gridConfig.set({
      ...prevConfig,
      filtersInitial: {
        connexPayAccountingDailyDetailId: id,
        fmsBookingId,
        merchantGuid,
        releasedDate,
        clientName: merchantName,
        orderNumber: connexPayTripReferenceNumber,
        cardLastFour: vccNumber,
        version: 1,
        description: connexPayDescription,
        cardGuid,
        connexpayChargeDateTime: chargeDate
      }
    })
  }

}
